import strings from 'strings';
import { SendoutStatus } from 'UI/constants/status';

const { title: STRINGS } = strings.sendoutsV2.drawers.declinationReasons;

export const REASONS_TITLE_BY_STATUS = {
  [SendoutStatus.NoOffer]: STRINGS.noOffer,
  [SendoutStatus.Declined]: STRINGS.declination
};
